export default __webpack_public_path__ + "static/media/healPoint.e1e70788.svg";